import React from 'react';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import {
  BiData,
  BiContextProvidedValue,
  UserNameClickBiEvent,
} from '@wix/da-bi/pkg/events';
import GroupCard from '@wix/da-shared-react/pkg/GroupCard';
import Button from '@wix/da-shared-react/pkg/Button';
import { useSelector } from 'react-redux';
import c from 'classnames';
import { getProfileOwner } from '../../../selectors/users';
import { useTranslation } from 'react-i18next';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { PapiModuleGroupMembers } from '@wix/da-papi-types';
import s from './GroupList.scss';

interface Props {
  moduleId: number;
  isWide?: boolean;
  canLoadMore?: boolean;
}

const GroupList: React.FC<Props> = ({ moduleId, isWide, canLoadMore }) => {
  const { t } = useTranslation();
  const profileOwner = useSelector(getProfileOwner);

  const { moduleData } = useModuleData<PapiModuleGroupMembers>(moduleId);
  const groups = moduleData?.results || [];

  const getBiData = group => {
    const { userId } = group;
    const biData = BiData<UserNameClickBiEvent>({
      evid: 101,
      typeid: ResourceType.GROUP,
      itemid: userId,
      sectionname: BiContextProvidedValue,
      creatorid: profileOwner?.user?.useridUuid,
    });
    return biData;
  };

  const renderGridElement = group => {
    return (
      <GroupCard
        key={group.username}
        group={group}
        className={s['group']}
        biData={getBiData(group)}
      />
    );
  };

  const renderGrid = () => {
    const elements = (isWide ? groups : groups.slice(0, 12)).map(
      renderGridElement
    );
    return (
      <ElementQueries
        widthBreakpoints={[640, 800]}
        className={c(s['grid'], !isWide && s['grid-flex'])}
      >
        {elements}
      </ElementQueries>
    );
  };

  return (
    <>
      {renderGrid()}
      {canLoadMore && (
        <Button view="b8" className={s['load-more-button']}>
          {t('widgets.groups.loadMore')}
        </Button>
      )}
    </>
  );
};
GroupList.displayName = 'GroupList';

export default GroupList;
